export const release = '02.11.2026 12:24';
